import React, { type JSX } from 'react';
import { default as DefaultChart } from '../charts/Component';

const Component = (props: any): JSX.Element => <DefaultChart {...props} color="#007bc1" />;

export default Component;
